export default __webpack_public_path__ + "static/assets/9dadf7aadc2b7df46d3fe173c07800ac.svg";